import { Icon } from '../../../../layout/Icon.jsx';
import { Pill } from '../../../../layout/Pill.jsx';
import { formatIQD, formatDateTime } from '../../../../shared/format.js';
import { refObject, refName, userName } from '../../helpers/refs.js';

const SOURCE_LABEL = {
  manual: 'يدوي',
  sales: 'بيع تلقائي',
  session_exit: 'إنهاء جلسة',
  card_topup: 'تعبئة كارت',
  other: 'أخرى'
};

const SOURCE_TONE = {
  manual: 'info',
  sales: 'muted',
  session_exit: 'muted',
  card_topup: 'orange',
  other: 'warning'
};

const METHOD_LABEL = {
  cash: 'نقدي',
  transfer: 'تحويل',
  external: 'خارجي'
};

export function RevenueRow({ revenue, onView }) {
  const cat = refObject(revenue.category || revenue.categoryId);
  const source = revenue.source || 'manual';
  const isAuto = source !== 'manual';
  const method = revenue.paymentMethod || 'cash';
  // إيراد إنهاء الجلسة مشتقّ من حركة قاصة الخروج ويحمل جلسته المرتبطة.
  const session = revenue.session || null;

  return (
    <tr className="border-b border-line">
      <td className="p-2.5 text-ink-2 whitespace-nowrap">{formatDateTime(revenue.date || revenue.createdAt)}</td>
      <td className="p-2.5">
        <div className="flex items-center gap-2">
          <span className="w-2.5 h-2.5 rounded-full flex-none" style={{ background: cat.color || '#22C55E' }} />
          <span className="font-semibold text-[12.5px] truncate" style={{ maxWidth: 140 }}>{cat.name || '—'}</span>
        </div>
      </td>
      <td className="p-2.5 font-bold" style={{ color: '#15803D' }}>+{formatIQD(revenue.amount || 0)}</td>
      <td className="p-2.5 text-[12px]">{METHOD_LABEL[method] || method}</td>
      <td className="p-2.5 text-[12px] text-ink-2 truncate" style={{ maxWidth: 140 }}>
        {refName(revenue.cashbox || revenue.cashboxId)}
      </td>
      <td className="p-2.5 text-[12px] text-ink-2 truncate" style={{ maxWidth: 140 }}>
        {userName(revenue.createdBy || revenue.createdById)}
      </td>
      <td className="p-2.5">
        <Pill variant={SOURCE_TONE[source] || 'muted'}>{SOURCE_LABEL[source] || source}</Pill>
        {isAuto ? (
          <div className="text-[10.5px] text-ink-3 mt-0.5">
            {revenue.derived ? 'محسوب من دفتر القاصة' : 'تلقائي من النظام'}
          </div>
        ) : null}
      </td>
      <td className="p-2.5 text-ink-2 text-[12px]" style={{ maxWidth: 240 }}>
        <div className="truncate">{revenue.description || revenue.notes || '—'}</div>
        {session && session.startTime ? (
          <div className="text-[10.5px] text-ink-3 truncate">
            جلسة: {formatDateTime(session.startTime)}
          </div>
        ) : null}
      </td>
      <td className="p-2.5">
        <div className="flex items-center gap-1 justify-end">
          <button
            type="button"
            className="btn"
            style={{ padding: '4px 8px' }}
            title="تفاصيل الإيراد"
            onClick={() => onView?.(revenue)}
          >
            <Icon name="search" size={13} />
          </button>
        </div>
      </td>
    </tr>
  );
}
